import { render, staticRenderFns } from "./level-dialog.vue?vue&type=template&id=b87ed598&scoped=true"
import script from "./level-dialog.vue?vue&type=script&lang=js"
export * from "./level-dialog.vue?vue&type=script&lang=js"
import style0 from "./level-dialog.vue?vue&type=style&index=0&id=b87ed598&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b87ed598",
  null
  
)

export default component.exports